import React from 'react'
import Recipe from '../components/food/Recipe'
import Footer from '../components/Footer'
import Nav from '../components/Nav'

function RecipePage() {
    return (
        <div>
            <Nav />
            <Recipe />
            <Footer />
        </div>
    )
}

export default RecipePage
